/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The station's state:
 *   * AVAILABLE:
 *   * UNAVAILABLE:
 *   * PARTIALLY_AVAILABLE:
 *   * UNKNOWN: no connection to the station for a preconfigured time
 */
export enum StationState {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE',
  PARTIALLY_AVAILABLE = 'PARTIALLY_AVAILABLE',
  UNKNOWN = 'UNKNOWN'
}
